import React, {useCallback, useEffect, useState} from 'react';
import UnitTable from './UnitTable';
import {fetchUnitList} from "../../../service/consistHistoryService";

const ConsistHistoryView = ({searchBy}) => {
    const [loading, setLoading] = useState(true);
    const [units, setUnits] = useState([]);

    const loadUnits = useCallback(async () => {
        setLoading(true);
        const responseBody = await fetchUnitList({search: searchBy, sortReverse: false});
        setUnits(responseBody && responseBody.units|| ['Failed to load data.']);
        setLoading(false);
    }, [setUnits, setLoading, searchBy]);
    useEffect(() => {
        loadUnits();
    }, [loadUnits]);

    return (
      <UnitTable units={units} loading={loading} searchBy={searchBy}/>
    );
};

export default ConsistHistoryView;